import { NOTIFICATIONS_ADD_ALERT_ACTION_TYPE, NOTIFICATIONS_ADD_NOTIFICATION_ACTION_TYPE, } from "../action/NotificationsActionsTypes";
import { removeAlert, removeNotification } from "../action/NotificationsActions";
export var notificationsMiddleware = function (api) {
    return function (dispatch) {
        return function (action) {
            if (action.type === NOTIFICATIONS_ADD_ALERT_ACTION_TYPE) {
                setTimeout(function () {
                    dispatch(removeAlert(action.payload.alert.key));
                }, 5000);
            }
            else if (action.type === NOTIFICATIONS_ADD_NOTIFICATION_ACTION_TYPE) {
                setTimeout(function () {
                    dispatch(removeNotification(action.payload.notification.key));
                }, 5000);
            }
            return dispatch(action);
        };
    };
};
